import { PromiseVoidFunction } from '@dreryk/react-common';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { MagistralDrugTemplateFormController } from './form/MagistralDrugTemplateForm.types';
import { MagistralDrugTemplatesCreateTemplateButton } from './MagistralDrugTemplatesCreateTemplateButton';
import { MagistralDrugTemplatesUpdateTemplateButton } from './MagistralDrugTemplatesUpdateTemplateButton';

type MagistralDrugTemplatesSendTemplateButtonProps = {
   handleSubmit: MagistralDrugTemplateFormController['handleSubmit'];
   disabled: boolean;
   onSuccess: PromiseVoidFunction;
};

export const MagistralDrugTemplatesSendTemplateButton = FormsTemplates.withTemplateSaveButton<MagistralDrugTemplatesSendTemplateButtonProps>(
   MagistralDrugTemplatesCreateTemplateButton,
   MagistralDrugTemplatesUpdateTemplateButton
);
